<template><!-- 远程复电 -->
  <div class="ycfd">
    <div class="info">
      <div class="info-left">
        <div style="margin: 0.2rem 0.2rem 0;">您的停电状态为：</div>
        <div class="info-item-value">{{consInfo.meterStatus == '1' ? '未停电' : consInfo.meterStatus == '0' ? '已停电': '未知'}}</div>
      </div>
      <div class="info-right">
        <div style="margin: 0.2rem 0.2rem 0;">您的余额为：</div>
        <div class="info-item-value">{{consInfo.balance}}&nbsp;元</div>
      </div>
    </div>
    <div v-if="consInfo.balance <= 0" style="padding: 0.1rem 5% 0 5%;font-size: 0.22rem;">您已欠费，请先
      <a style="color: #39bf93;" @click="toRecharge()">交费</a></div>
    <div style="padding: 0.5rem 5% 0 5%;">
      <van-button @click="ycfd" type="primary" block :disabled="consInfo.balance<=0 || consInfo.meterStatus != '0'">立即复电</van-button>
    </div>
    <div class="note_box">
      <div class="note_title">温馨提示</div>
      <p>1、远程复电需安装了费控智能电表的用户，用户的余额大于零（未欠费）。</p>
      <p>2、复电指令下发后有一定延迟时间，请勿重复使用此功能。</p>
      <p>3、由于不可控因素复电失败，请致电系统管理员进行咨询。</p>
    </div>
  </div>
</template>

<script>
import { ycfd, queryXcfdPageInfo } from "@/api/user.js";
import Vue from "vue";
import { Notify, DatetimePicker, Popup, Toast } from "vant";
Vue.use(Notify);
Vue.use(DatetimePicker);
Vue.use(Popup);
export default {
  data() {
    return {
      consInfo:{consId: "", balance:"0.00"},
    };
  },
  created() {
    if (this.$route.query.consId) {
      this.consInfo.consId = this.$route.query.consId;
      this.queryXcfdPageInfo();
    }
  },
  methods: {
    queryPowerUseBill() {
      if (this.consId) {
        queryPowerUseBill({ consId: this.consId, month: this.month }).then(
          res => {
            if (res.data.status == 200) {
              this.bill = res.data.object;
            } else {
              this.bill = null;
            }
        });
      }
    },
    ycfd() {
      Toast.loading({
        message: '执行中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 5
      });
      ycfd(this.consInfo.consId).then(res => {
        Toast.clear();
        if (res.data.status == 200) {
          Notify({ type: "success", message: '远程复电执行中，请耐心等待' });
        } else {
          Notify({ type: "danger", message: res.data.msg });
        }
      });
    },
    queryXcfdPageInfo() {
      queryXcfdPageInfo(this.consInfo.consId).then(res => {
        if (res.data.status == 200) {
          this.consInfo = res.data.object;
        } else {
          Notify({ type: "danger", message: res.data.msg });
        }
      });
    },
    toRecharge() {
      this.$router.push({
        path: `/tcmr/WxRecharge?state=${this.consInfo.consId}`
      });
    },
  }
};
</script>


<style  scoped>
.ycfd {
  text-align: left;
  font-size: 0.25rem;
}
.info {
  border-radius: 5px;
  height: 80px;
  margin: 5% 5% 0 5%;
}
.info-left {
  float: left;
  width: 50%;
  border: 1px solid #ebebeb;
  box-sizing: border-box;
}
.info-right {
  float: left;
  width: 50%;
  border: 1px solid #ebebeb;
  border-left: 0px;
  box-sizing: border-box;
}

.info-item-value {
  text-align: center;
  padding: 0.1rem 0 0.24rem;
  color: #33bf93;
  font-weight: 600;
}

.note_title {
  top: -13px;
  left: 110px;
  width: 118px;
  font-size: 20px;
  color: #33bf93;
  font-weight: bold;
  position: absolute;
  background: #fff;
  text-align: center;
}

.note_box {
  padding: 20px;
  margin: 0 20px;
  margin-top: 50px;
  font-size: 14px;
  position: relative;
  border: 1px solid #33bf93;
}
</style>